import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classes from './SearchBarA.module.scss';

const SearchBarA = (props) => {
  const {
    keyword = '',
    setKeyword,
    setActivePage,
    setShowingAll,
  } = props;

  const handleChange = (evt) => {
    setKeyword(evt.target.value);
    if (setActivePage) setActivePage(1);
    if (setShowingAll) setShowingAll(false);
  };

  return (
    <div className={classes.searchContainer}>
      <input
        className={classes.searchInput}
        type='search'
        value={keyword}
        placeholder='Search'
        onChange={(e) => handleChange(e)}
        aria-label='Search'
      />
      <FontIcon icon='far fa-search' className={classes.searchIcon} />
    </div>
  );
};

SearchBarA.propTypes = {
  /**
   * Keyword goes into input
  */
  keyword: PropTypes.string,
  /**
   * Function to set the keyword when the text changes
  */
  setKeyword: PropTypes.func.isRequired,
  /**
   * Function to set the active page in pagination when the text changes
  */
  setActivePage: PropTypes.func.isRequired,
  /**
   * Function for showing all results
  */
  setShowingAll: PropTypes.func,
};

export default SearchBarA;
